import metaApiClient from './meta-client';

export interface UtmFixAccepted {
    status: string;
    task_id: string;
}

export interface UtmFixResult {
    processed: number;
    updated: number;
    skipped: number;
    error_list: { page_id: string; error: string }[];
}

export interface UtmFixStatus {
    status: string;
    result: UtmFixResult | null;
    error: string | null;
    processed?: number;
    updated?: number;
    skipped?: number;
    errors?: number;
}

export async function triggerUtmFix(token: string, user_ids: number[]): Promise<UtmFixAccepted> {
    const response = await metaApiClient.post<UtmFixAccepted>('/admin/chatfood/utm-fix', { token, user_ids });
    return response.data;
}

export async function getUtmFixStatus(task_id: string): Promise<UtmFixStatus> {
    const response = await metaApiClient.get<UtmFixStatus>(`/admin/chatfood/utm-fix/status/${task_id}`);
    return response.data;
}
